import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row chat-box" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexVideo',
  setup(__props) {

const searchChat = defineAsyncComponent(() => import("@/components/commen/searchChat.vue"))
const Card8 = defineAsyncComponent(() => import("@/components/commen/card/cardData8.vue"))
const chatRight = defineAsyncComponent(() => import("@/components/theme/chat/videochat/chatRight.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Chat",
      title: "Video Chat"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(searchChat)),
        _createVNode(_unref(Card8), {
          colClass: "col call-chat-body",
          cardbodyClass: "p-0"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(chatRight))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})